import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { ImageComponent } from 'components/atoms/image/image.component';
import type { ILocaleWithLink } from 'src/services/url-localise/entities';
import type { THeaderLayoutTheme } from 'src/shared/types/color-schemes-and-themes';

import { imageConfig } from './entities/image-config';

@Component({
    selector: 'website-language-selector-section',
    templateUrl: './language-selector-section.component.html',
    styleUrls: ['./language-selector-section.component.scss'],
    imports: [NgClass, ImageComponent],
})
export class LanguageSelectorSectionComponent {
    public readonly theme = input<THeaderLayoutTheme>();
    public readonly languages = input<ILocaleWithLink[][]>();
    public readonly isAnyNavItemOpen = input<boolean>();
    public readonly isCurrentNavItemOpened = input<boolean>();
    public imageConfig = imageConfig;

    public readonly LANGUAGE_SELECTOR_PATH = computed(
        () => `/tp/static/assets/img/header-v2/language-selector-${this.theme()}.png`
    );
}
